import { useState } from 'react';
import { Link } from 'react-router-dom';

const LINKS = [
  { label: 'Jobs & Scholarships', to: '/openings' },
  // { label: 'Assessment', to: '/apply' },
  { label: 'Courses', to: '/courses' },
  { label: 'Testimonials', to: '/testimonials' },
  { label: 'About', to: '/about' },
  { label: 'FAQ', to: '/faq' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 w-full z-50 bg-[#f7f9fb]/80 backdrop-blur-md border-b border-white/20 shadow-sm">
      <div className="flex justify-between items-center px-4 md:px-6 max-w-[1280px] mx-auto h-20">
        <Link to="/" className="flex items-center gap-2">
          <img src="/images/logo_w_nobg.png" alt="IASC Consultancy" className="h-10 w-10 object-contain rounded-lg" />
          <span className="text-xl font-bold text-[#00255a] hidden sm:block">IASC Consultancy</span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((link) => (
            <Link key={link.to} className="text-[#44474f] hover:text-[#00255a] py-1 transition-colors" to={link.to}>
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-4">
          <Link className="text-[#00255a] font-bold px-4 py-2 rounded-lg hover:bg-[#1e3c72]/10" to="/login">Login</Link>
          <Link
            className="text-white px-6 py-3 rounded-lg font-bold hover:scale-105 transition-all shadow-md"
            style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 60%, #ff7b7b 100%)' }}
            to="/apply"
          >
            Apply Now
          </Link>
        </div>

        {/* Mobile toggle */}
        <button onClick={() => setMenuOpen(!menuOpen)} className="md:hidden p-2 text-[#00255a]">
          <span className="material-symbols-outlined">{menuOpen ? 'close' : 'menu'}</span>
        </button>
      </div>

      {/* Mobile dropdown panel */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-[#e2e8f0] shadow-lg px-4 py-4 space-y-1 max-h-[calc(100vh-5rem)] overflow-y-auto">
          {LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => setMenuOpen(false)}
              className="block px-4 py-3 rounded-lg text-[#44474f] hover:bg-[#f2f4f6] hover:text-[#00255a] font-semibold"
            >
              {link.label}
            </Link>
          ))}
          <div className="pt-3 mt-3 border-t border-[#e2e8f0] flex flex-col gap-3">
            <Link
              to="/login"
              onClick={() => setMenuOpen(false)}
              className="text-center px-4 py-3 rounded-lg text-[#00255a] font-bold border border-[#00255a]/20"
            >
              Login
            </Link>
            <Link
              to="/apply"
              onClick={() => setMenuOpen(false)}
              className="text-center text-white px-6 py-3 rounded-lg font-bold shadow-md"
              style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 60%, #ff7b7b 100%)' }}
            >
              Apply Now
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}